import { useState } from 'react';
import Drawer from '@liquidweb-dev/undercurrent/Drawer';
import useAssetDetails from 'modules/queries/asset/useDetails';
import hostingDetailsAlsowith from 'containers/pages/servers/details/hostingDetailsAlsowith';
import DialogDestroyAcronis from 'components/standard/DialogDestroyAcronis';
import DialogDestroyCloudBackup from 'components/standard/DialogDestroyCloudBackup/DialogDestroyCloudBackup';
import BackupTypeSwitch from './BackupTypeSwitch';
import BackupSettingsError from './Error';
import BackupSettingsLoading from './Loading';

export interface BackupSettingsProps
	extends Omit<React.ComponentProps<typeof Drawer>, 'onClose'> {
	uniqId?: string;
	onClose: () => void;
}

const BackupSettings: React.FC<BackupSettingsProps> = ({
	onClose,
	uniqId,
	...rest
}) => {
	const [isDestroyAcronisDialogOpen, setDestroyAcronisDialogOpen] =
		useState(false);
	const [isDestroyCloudBackupDialogOpen, setDestroyCloudBackupDialogOpen] =
		useState(false);

	const {
		data: assetDetails,
		isLoading: isAssetDetailsLoading,
		isError: isAssetDetailsError,
	} = useAssetDetails(
		{
			alsowith: hostingDetailsAlsowith,
			uniq_id: uniqId || '',
		},
		{
			enabled: Boolean(uniqId),
			refetchInterval: 30000,
		},
	);

	const handleDestroyAcronis = () => {
		onClose();
		setDestroyAcronisDialogOpen(true);
	};

	const handleDestroyAcronisDialogClose = () => {
		onClose();
		setDestroyAcronisDialogOpen(false);
	};

	const handleDestroyCloudBackup = () => {
		onClose();
		setDestroyCloudBackupDialogOpen(true);
	};

	const handleDestroyCloudBackupDialogClose = () => {
		onClose();
		setDestroyCloudBackupDialogOpen(false);
	};

	return (
		<>
			<Drawer anchor="right" onClose={onClose} {...rest}>
				{isAssetDetailsLoading && <BackupSettingsLoading onClose={onClose} />}
				{!isAssetDetailsLoading && assetDetails && (
					<BackupTypeSwitch
						assetDetails={assetDetails}
						onDestroyAcronis={handleDestroyAcronis}
						onDestroyCloudBackup={handleDestroyCloudBackup}
						onClose={onClose}
					/>
				)}
				{isAssetDetailsError && <BackupSettingsError onClose={onClose} />}
			</Drawer>
			<DialogDestroyAcronis
				open={isDestroyAcronisDialogOpen}
				uniqId={assetDetails?.backupsAndStorage?.acronis?.uniq_id ?? ''}
				onClose={handleDestroyAcronisDialogClose}
			/>
			<DialogDestroyCloudBackup
				open={isDestroyCloudBackupDialogOpen}
				uniqId={assetDetails?.uniq_id ?? ''}
				domain={assetDetails?.domain}
				onClose={handleDestroyCloudBackupDialogClose}
			/>
		</>
	);
};

export default BackupSettings;
